import React, { useState } from "react";
import {
  Stack,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ImportExportIcon from "@mui/icons-material/ImportExport"; // better icon for sorting

const SortAndFilterControls = ({
  setSortOption,
  filterTags,
  setFilterTags,
  allDietaryOptions,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorSort, setAnchorSort] = useState(null);
  const [anchorFilter, setAnchorFilter] = useState(null);

  const handleSortClick = (e) => setAnchorSort(e.currentTarget);
  const handleFilterClick = (e) => setAnchorFilter(e.currentTarget);
  const handleCloseSort = () => setAnchorSort(null);
  const handleCloseFilter = () => setAnchorFilter(null);

  const toggleFilterTag = (tag) => {
    setFilterTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <IconButton onClick={handleSortClick}>
        <ImportExportIcon fontSize="medium" />
        {!isMobile && (
          <Typography fontSize={14} sx={{ ml: 0.5 }}>
            Sort
          </Typography>
        )}
      </IconButton>
      <Menu
        anchorEl={anchorSort}
        open={Boolean(anchorSort)}
        onClose={handleCloseSort}>
        <MenuItem disabled>Sort By</MenuItem>
        <MenuItem
          onClick={() => {
            setSortOption("alphabetical_asc");
            handleCloseSort();
          }}>
          A to Z
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortOption("alphabetical_desc");
            handleCloseSort();
          }}>
          Z to A
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortOption("price_asc");
            handleCloseSort();
          }}>
          Price: Low to High
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSortOption("price_desc");
            handleCloseSort();
          }}>
          Price: High to Low
        </MenuItem>
      </Menu>

      <IconButton onClick={handleFilterClick}>
        <FilterListIcon fontSize="medium" />
        {!isMobile && (
          <Typography fontSize={14} sx={{ ml: 0.5 }}>
            Filter
          </Typography>
        )}
      </IconButton>
      <Menu
        anchorEl={anchorFilter}
        open={Boolean(anchorFilter)}
        onClose={handleCloseFilter}>
        <MenuItem disabled>Filter By</MenuItem>
        {allDietaryOptions.map((tag) => (
          <MenuItem key={tag} onClick={() => toggleFilterTag(tag)}>
            {filterTags.includes(tag) ? "✓ " : ""} {tag}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};

export default SortAndFilterControls;
